import { DrawerSection } from '@components/ui/drawer/section';
import { useTranslation } from 'react-i18next';
import { RadioGroup } from '@components/ui/radio';
import { Button } from '@components/ui/button';
import { useSchedulerSidebar } from '@contexts/scheduler/sidebar';
import { useSchedulerContext } from '@contexts/scheduler';
import {
  getCrewMembersFromForeman,
  mapCrewMembersToSchedulerSidebarCrewMembers,
} from '@contexts/scheduler/sidebar/helpers';
import { SchedulerSidebarConfirmOption } from '../option';
import { useDropdownsContext } from '@contexts/dropdowns';
import { useAccess } from '@hooks/access';

export const SchedulerSidebarConfirmCrewAssignment = () => {
  const {
    confirm: {
      crewAssignment: { open, keepCurrentCrew },
    },
    crewMembers,
    setState,
  } = useSchedulerSidebar();
  const access = useAccess();

  const {
    active: { schedule },
  } = useSchedulerContext();

  const { fieldUsers } = useDropdownsContext();

  const { t } = useTranslation('app', { keyPrefix: 'schedule.confirm.crewAssignment' });
  const { t: tActions } = useTranslation('app', { keyPrefix: 'actions' });

  const handleCancel = () => {
    setState((prev) => ({
      ...prev,
      confirm: {
        ...prev.confirm,
        defaultCrew: false,
        crewAssignment: { ...prev.confirm.crewAssignment, open: false },
      },
    }));
  };

  const handleConfirm = () => {
    const defaultCrewMembers = getCrewMembersFromForeman(schedule.foreman?.id, fieldUsers);

    setState((prev) => ({
      ...prev,
      defaultCrew: !prev.confirm.crewAssignment.keepCurrentCrew,
      crewMembers: prev.confirm.crewAssignment.keepCurrentCrew
        ? prev.crewMembers.filter((el) => el.userId !== schedule.foreman?.id)
        : mapCrewMembersToSchedulerSidebarCrewMembers(defaultCrewMembers),
      confirm: {
        ...prev.confirm,
        crewAssignment: { ...prev.confirm.crewAssignment, keepCurrentCrew: true, open: false },
      },
    }));
  };

  const currentNames = crewMembers
    .filter((el) => el.userId !== schedule?.foreman?.id)
    .map((el) => el.name);
  const defaultNames = mapCrewMembersToSchedulerSidebarCrewMembers(
    getCrewMembersFromForeman(schedule?.foreman?.id, fieldUsers),
  ).map((el) => el.name);

  if (!open) return null;

  return (
    <DrawerSection title={t('title')} alwaysOpen>
      <div className="flex flex-col gap-4">
        <RadioGroup
          value={keepCurrentCrew ? 'keep' : 'refresh'}
          disabled={access.readOnly}
          onValueChange={(v) => {
            setState((prev) => ({
              ...prev,
              confirm: {
                ...prev.confirm,
                crewAssignment: { ...prev.confirm.crewAssignment, keepCurrentCrew: v === 'keep' },
              },
            }));
          }}
          className="flex flex-col gap-2">
          <SchedulerSidebarConfirmOption
            id="crew-keep"
            value="keep"
            label={t('keep')}
            items={currentNames}
            emptyLabel={t('empty')}
          />
          <SchedulerSidebarConfirmOption
            id="crew-refresh"
            value="refresh"
            label={t('refresh', { fieldUser: schedule?.foreman.fullName || '' })}
            items={defaultNames}
            emptyLabel={t('empty')}
          />
        </RadioGroup>
        <div className="flex justify-end gap-2 pt-1">
          <Button variant="ghost" type="button" size="sm" onClick={handleCancel}>
            {tActions('cancel')}
          </Button>
          <Button disabled={access.readOnly} type="button" size="sm" onClick={handleConfirm}>
            {tActions('confirm')}
          </Button>
        </div>
      </div>
    </DrawerSection>
  );
};
